function NewsletterPageModel() {
    var self = this;

    self.NewsletterModel = ko.observable(new NewsletterModel());
    self.isRegistered = ko.observable(false);

    self.Submit = function () {
        self.NewsletterModel().GoogleRecaptchaCode(self.GetRecaptchaCode());
        var data = ko.mapping.toJSON(self.NewsletterModel);
        self.NewsletterModel().Loading(true);
        $.ajax({
            url: ajaxUrls.newsletter.AddUserToNewsletter,
            type: 'POST',
            data: data,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
        }).done(function (returnArr) {
            self.NewsletterModel().Errors.removeAll();
            if (!returnArr.Success) {
                $.each(returnArr.Errors, function (index, item) {
                    self.NewsletterModel().Errors.push(item);
                });
                grecaptcha.reset();
            } else {
                self.NewsletterModel().Saved(true);
                // redirect to confirmation page
                window.location.pathname = ajaxUrls.newsletter.PreConfirmation;
                }
        }).fail(function () {
            alerts.error();
            grecaptcha.reset();
        }).always(function() {
            fireDataLayerEventRegister();
            self.NewsletterModel().Loading(false);
        });
    };

    self.GetRecaptchaCode = function () {
        return $('.g-recaptcha-response').val();
    };
}

function fireDataLayerEventRegister() {
    window.dataLayer =
        window.dataLayer || [];
    window.dataLayer.push({
        'event': 'formSubmission',
        'form_name':
            'Newsletter_pre_registration',
    });
}